import ConditionalVariationMenu from "@builder/components/app/OliverBuildFrame/ConditionalVariationMenu";
import { componentWrapperMap } from "@builder/components/app/OliverBuildFrame/map";
import RenderFromNode from "@builder/components/app/OliverBuildFrame/RenderFromNode";
import { buildVariation } from "@builder/components/app/OliverBuildFrame/RenderVariationNodes";
import { SmartGridNode } from "@common/build/types";
import { BuilderComponentProps } from "@common/components/BuilderInterface";
import BuilderSmartGrid from "@common/components/BuilderSmartGrid";
import HookWrapper from "@common/components/HookWrapper";

const SmartGridWrapper = (props: BuilderComponentProps & { saveLayout?: { editMode: boolean } }) => {
    const { children, ...rest } = props;
    const { smartGrid } = props.node as SmartGridNode;

    const smartTile = props.children && Array.isArray(props.children) ? props.children[0] : undefined;

    if (!smartTile) {
        return null;
    }

    const { props: smartTileProps } = smartTile;

    return (
        <HookWrapper component={BuilderSmartGrid} {...rest}>
            {Array.from({ length: (smartGrid?.rows || 3) * (smartGrid?.columns || 3) }).map((_, index) =>
                index === 0 ? (
                    componentWrapperMap.smartTile(
                        {
                            ...smartTileProps,
                            node: smartTileProps.node,
                            children: (
                                <ConditionalVariationMenu id={smartTileProps.node.id} amount={smartTileProps.node.conditionalVariations.length} />
                            )
                        },
                        `${smartTileProps.node.id}|${index}`
                    )
                ) : (
                    <RenderFromNode key={index} node={buildVariation(smartTileProps.node, 0, index.toString())} disabled noSelectedMenu />
                )
            )}
        </HookWrapper>
    );
};

export default SmartGridWrapper;
